const arraysEqualIgnoreOrder = function (arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  return arr1.slice().sort().every((value, index) => value === arr2.slice().sort()[index]);
}

export {
  arraysEqualIgnoreOrder
}
